import useShowSuccess from 'hooks/useShowSuccess'
import { useCancelTransactionMutation } from '../../../graphql'

export default function useCancelTransactionHandler( options?: any ) {
	const [ cancelTransaction ] = useCancelTransactionMutation( options )
	const showSuccess = useShowSuccess()

	return async( transactionId: number ) => {
		await cancelTransaction( { variables: { transactionId } } )
		showSuccess( `cancelTransaction${Date.now()}`, 'Transaction cancelled' )
	}
}
